// extracted by css-extract-rspack-plugin
export default {"navigation":"Navigation-module__navigation--zxtEs","sections":"Navigation-module__sections--vS2jc","section":"Navigation-module__section--yJhTH"};